<section class="bfa-component-wrapper" *ngIf="data?.success; else noData">
	<dl-section-header [subTitle]="subTitle" [title]="title" [asOfDate]="asOfDate"></dl-section-header>
	<bfa-accordion>
		<ng-container *ngFor="let tab of data.tabs; index as idx">
			<accordion-panel
				[isCollapsed]="!tab?.displayConfig?.active"
				(onToggleChange)="parentCollapsed[idx] = !parentCollapsed[idx]"
				*ngIf="tab?.displayConfig?.visible && tab?.displayConfig?.isIterative"
			>
				<header><ng-container *ngTemplateOutlet="accordionHeaderContent; context: { tab: tab }"></ng-container></header>
				<content *ngIf="tab.config && tab.config.id === 'fi.sleeve.characteristics'">
					<ng-container *ngIf="!tab.error; else tabError">
						<section class="margin-standard">
							<dl-display-table [data]="tab" [bordered]="true" [padded]="true" [striped]="true" [attr.data-cy]="tab?.config?.id + '-table'"> </dl-display-table>
						</section>
						<section *ngIf="asOfDateSNP" class="disclaimer-container margin-standard">
							<span dcrHTMLKey="BETA_SNP500_AS_OF">The data for Beta to S&P 500 is as of</span> {{ asOfDateSNP }}
						</section>
						<risk-characteristic-insights *componentId="'risk.fixed.income.insights'; let res" [data]="res"></risk-characteristic-insights>
						<ac-tpm-disclosure></ac-tpm-disclosure>
					</ng-container>
				</content>
				<ng-template #tabError>
					<em class="not-applicable margin-standard" [dcrHTMLKey]="tab.error.errorCodes[0]">{{ tab.error.debugMessage }}</em>
				</ng-template>
			</accordion-panel>
		</ng-container>
		<accordion-panel *ngIf="decompositionTabs.length > 0" [isCollapsed]="!(decompHeaderTab.displayConfig && decompHeaderTab.displayConfig.active)">
			<header><ng-container *ngTemplateOutlet="accordionHeaderContent; context: { tab: decompHeaderTab }"></ng-container></header>
			<content>
				<risk-decomposition-table
					[tabId]="'fi.total.risk.decomposition'"
					[decompositionTabs]="decompositionTabs"
					[totalPortfolioTab]="totalSumTab"
					[activeOnlyTab]="activeSumTab"
					[contributionTabs]="[data.tab['fi.total.risk.decomposition.contributions']]"
				>
				</risk-decomposition-table>
				<ac-disclosure>
					<ac-tpm-disclosure></ac-tpm-disclosure>
					<span dcrHTMLKey="EQUITY_ACTIVE_RISK_DECOMPOSITION_DISCLAIMER">FI_ACTIVE_RISK_DECOMPOSITION_DISCLAIMER</span>
				</ac-disclosure>
			</content>
		</accordion-panel>
	</bfa-accordion>
</section>
<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
<ng-template #accordionHeaderContent let-tab="tab">
	<dl-tooltip-section-header [tab]="tab"></dl-tooltip-section-header>
</ng-template>
